import { createQueryKeySet } from '@akin-home/utils/react-query';

export const goal_query_keys = createQueryKeySet({ key: 'goals' });
